import React from "react";
import { ArrowRight, ArrowUp, Circle, X } from "@phosphor-icons/react";
import HideComponentWrapper from "../HideComponentWrapper";
import Styles from "./Badge.module.css";
import { IBadgeProps } from "../../models";

const Badge: React.FC<IBadgeProps> = (props: IBadgeProps) => {
	const { size, type, icon = null, color, className = "", style = {}, iconComponent = <></>, iconPosition = "left" } = props;
	const getIcon = () => {
		switch (icon) {
			case "avatar":
				return iconComponent;
			case "dot":
				return <Circle weight="fill" className={`${Styles["icon_dot"]} ${props.iconClass}`} />;
			case "x-close":
				return <X weight="bold" className={`${Styles["icon_xclose"]} ${props.iconClass}`} />;
			case "trailing":
				return <ArrowRight weight="bold" className={`${Styles["icon_trailing"]} ${props.iconClass}`} />;
			case "leading":
				return <ArrowUp weight="bold" className={`${Styles["icon_leading"]} ${props.iconClass}`} />;
			default:
				return <></>;
		}
	};
	return (
		<div
			className={`${Styles.badge} ${Styles["size_" + size]} ${Styles["color_" + color]} ${Styles["type_" + type]} ${className}`}
			style={style}
			ref={props.ref}
			aria-description={"icon_" + icon}
			onClick={props.onClick}
		>
			<HideComponentWrapper show={!!icon && iconPosition === "left"}>{getIcon()}</HideComponentWrapper>
			{props.children}
			<HideComponentWrapper show={!!icon && iconPosition === "right"}>{getIcon()}</HideComponentWrapper>
		</div>
	);
};

Badge.displayName = "Badge";
export default Badge;
